// extracted by mini-css-extract-plugin
module.exports = {"title":"ValueTileList_title__uDGar","list":"ValueTileList_list__kzVls","item":"ValueTileList_item__hLmY_"};